
import cvFile from './Cv/ALi Hasan - Frontend developer.pdf';
import { motion } from "motion/react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaDownload, FaLinkedin,FaGithub } from "react-icons/fa";
import { useContext } from 'react';
import { WindowSize } from './Components/Context/WindoContext';
const highlights = ['3+ Years Experience','Government Platforms', 'React.js', 'REST API Integration',"Git & GitHub","AI-Assisted Development Workflow"];

export default function Hero() {
  //context for media
  const mediaSize=useContext(WindowSize);
  //mapping
  const highlightItems = highlights.map((item) => (
    <li key={item}>
      <span className="check-mark">✓</span> {item}
    </li>
  ));
  return (
    <section id="hero" className="section hero">
      <div>  
          <motion.span className="eyebrow"
          initial={{ opacity: 0 ,translateY:"60px" }}
          whileInView={{ opacity: 1 ,translateY:"0px" }}
          transition={{ duration: 1 ,delay:0.2 }}
          viewport={{once:true}}>
            Frontend Web Developer</motion.span>
        
        <motion.h1
        initial={{ opacity: 0 ,translateY:"60px" }}
        whileInView={{ opacity: 1 ,translateY:"0px" }}
        transition={{ duration: 1 ,delay:0.6 }}
        viewport={{once:true}}>
          Building modern web applications with React that are fast, scalable, and user-focused.
          </motion.h1>
        <motion.p className="hero-text"
        initial={{ opacity: 0 ,translateY:"60px" }}
          whileInView={{ opacity: 1 ,translateY:"0px" }}
          transition={{ duration: 1 ,delay:1 }}
          viewport={{once:true}}>
         I'm Ali Monther Hasan, a Frontend Developer with professional experience building service-oriented web platforms. Alongside my work in a software company, I've delivered freelance websites tailored to clients' unique business needs, focusing on responsive design, clean code, and seamless user experiences.
        </motion.p>
        <motion.div
          initial={{ opacity: 0 ,translateY:"60px" }}
          animate={{ opacity: 1 ,translateY:"0px" }}
          transition={{ duration: 1 ,delay:1.4 }}
          viewport={{once:true}}>
        <div className="hero-actions">
          <Link className="btn btn-primary" to="/contact">
            Let&apos;s Connect  <FaArrowRight />
          </Link>
          <Link className="btn btn-secondary" to="/featured-projects">
            View Projects  <FaArrowRight />
          </Link>
        </div>
        <ul className="hero-highlights">
          <li>React.js</li>
          <li>Responsive UI</li>
          <li>API Integration</li>
          <li>Git & GitHub</li>
        </ul>
        </motion.div>
      </div>

      <motion.div className="hero-card"
      initial={{  opacity: 0,translateY: "60px" }}
      whileInView={{ opacity: 1,translateY: 0}}
        whileHover={{ scale: 1.02 }}
          transition={{
            opacity:{
                  duration:1, delay:mediaSize.windowSize>768?1.8:0.2
              },
              translateY:{
                  duration:1, delay:mediaSize.windowSize>768?1.8:0.2
              },
              scale:{
                duration:0.2, delay:0
              }
    
        }}
      // transition={{ duration: 1, delay:mediaSize.windowSize>768?1.8:0.2 }}
      viewport={{once:true}}>
        <h2>Frontend Web Developer</h2>
        <ul className="hero-card-highlights">
          {highlightItems}
        </ul>
        <div className="contact-links">
          <a
            className="contact-link"
            href={cvFile}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download CV"
          >
            <FaDownload aria-hidden="true" />
            <span>CV</span>
          </a>
          <a
            className="contact-link"
            href="https://www.linkedin.com/in/ali-hasan-67100b38a"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open LinkedIn profile"
          >
            <FaLinkedin aria-hidden="true" />
            <span>LinkedIn</span>
          </a>
          <a
            className="contact-link"
            href="https://github.com/Ali-Hasan-developer/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open GitHub profile"
          >
            <FaGithub aria-hidden="true" />
            <span>GitHub</span>
          </a>
        </div>
        <div style={{textAlign:'center',marginTop:'32px',
          borderTop:'1px solid var(--accent)',paddingBlock:'16px'}}>
          <p>Open to Frontend Opportunities</p>
        </div>
        
      </motion.div>
    </section>
  );
}

